export default {
  title: 'Warenkorb',
};
